import React from 'react'
import { styled, useTheme } from '@mui/material/styles'
import { Grid, Typography, useMediaQuery } from '@mui/material'
import ReactPaginate from 'react-paginate'

const PREFIX = 'Pagination'

const classes = {
  active: `${PREFIX}-active`,
  disabledButton: `${PREFIX}-disabledButton`,
  link: `${PREFIX}-link`,
  nextPreviousButton: `${PREFIX}-nextPreviousButton`,
  pagination: `${PREFIX}-pagination`,
  noBookmark: `${PREFIX}-noBookmark`,
}

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.active}`]: {
    color: 'black !important',
    cursor: 'text !important',
    textDecoration: 'none !important',
  },

  [`& .${classes.disabledButton}`]: {
    display: 'none',
    cssFloat: 'left',
  },

  [`& .${classes.link}`]: {
    color: 'blue',
    padding: '20px',

    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },

  [`& .${classes.nextPreviousButton}`]: {
    color: 'blue',
    display: 'inline-block !important',
    overflow: 'visible',
    textAlign: 'left',

    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },

  [`& .${classes.pagination}`]: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    listStyleType: 'none',
    width: '100%',
  },

  [`& .${classes.noBookmark}`]: {
    marginTop: theme.spacing(3),
    minHeight: '70vh',
  },
}))

type Props = {
  pageCount: number
  pageNumber: number
  handlePageClick: (paginationData: { selected: number }) => void
}

export function Pagination(props: Props) {
  const theme = useTheme()
  const isPcScreen = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <StyledGrid container={true} justifyContent="center">
      {/* @ts-ignore */}
      <ReactPaginate
        previousLabel={'前へ'}
        nextLabel={'次へ'}
        breakLabel={'...'}
        pageCount={props.pageCount}
        marginPagesDisplayed={isPcScreen ? 2 : 2}
        pageRangeDisplayed={isPcScreen ? 3 : 0}
        initialPage={props.pageNumber - 1}
        onPageChange={props.handlePageClick}
        disableInitialCallback={true}
        containerClassName={classes.pagination} // style for ul
        activeLinkClassName={classes.active} // style for active number
        disabledClassName={classes.disabledButton} // disabled previous & next
        pageLinkClassName={classes.link} // classname on tag a of each page element except previous & next
        previousLinkClassName={classes.nextPreviousButton} // The classname on tag a of the previous button.
        nextLinkClassName={classes.nextPreviousButton} // The classname on tag a of the next button.
      />
    </StyledGrid>
  )
}

export const EmptyPaginationPage = (props: { title: string }) => (
  <Grid xs={12} className={classes.noBookmark} item={true}>
    <Typography align="center">{props.title}</Typography>
  </Grid>
)
